import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { FieldValue } from '../../../../profile-form/entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../profile-form/helpers/fields/field-read.helper';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class TextFieldColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.WIDE;
    protected readonly DISABLE_SORT: boolean = false;
    private readonly fieldReadHelper: FieldReadHelper = inject(FieldReadHelper);
    private readonly translateService: TranslateService = inject(TranslateService);

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return (record: ApiFragment) => {
            const value: FieldValue = this.fieldReadHelper.getFieldValue(profileField.FieldDefinition, record);

            return this.fieldValueToTextCell(value);
        };
    }

    private fieldValueToTextCell(fieldValue: FieldValue): TextCell {
        if (fieldValue === null) {
            return new TextCell('');
        }

        if (Array.isArray(fieldValue)) {
            return new TextCell(
                this.getListLabel(fieldValue),
                true,
                true,
                undefined,
                this.getListLabel(fieldValue, true)
            );
        }

        if (typeof fieldValue === 'object') {
            return new TextCell(this.translateService.instant('generic-overview.columns.unsupported'));
        }

        return new TextCell(fieldValue.toString(), false);
    }

    private getListLabel(fieldValue: string[], full = false): string {
        if (fieldValue.length === 0) {
            return '';
        } else if (fieldValue.length === 1) {
            return `${fieldValue[0]}\n`;
        } else {
            return full
                ? fieldValue.map(value => value).join(', ')
                : `${fieldValue[0]}\n<i>${this.translateService.instant('ui.and-others', { amount: fieldValue.length - 1 })}</i>`;
        }
    }
}
